import { toast, TypeOptions } from "react-toastify";
import { useEffect, useRef } from "react";
import { addNewDefaultSelectorValue, PageControl } from "../constants";
import { formatValueAsDate } from "./DateUtils";
import DatePicker from "react-date-picker";
import moment from "moment";
import _ from "lodash";
import React from "react";
import NumberFormat from "react-number-format";
import axiosInstance from "../../axiosInstance";
import Button from "../../components/common/form/Button";
import TailSpinLoader from "../../components/common/TailSpinLoader";

export const validateTaxYear = (year: any, records: any, isRequired = true) => {


    if ((year === null || year === "") && !isRequired) {
        return null;
    }


    if ((year === null || year === "") && isRequired) {
        return "Year is required!";
    }

    if (year?.toString().startsWith("0")) {
        return "Year cannot start with zero!";
    }

    if (year?.toString().includes(".")) {
        return "Year cannot contain decimal value!";
    }

    if (year < 1950) {
        return "Year must be greater than 1950!";
    }

    if (year > 2050) {
        return "Year must be smaller than 2050!";
    }

    if (containsRecordForYear(year, records)) {
        return "A record for " + year + " already exists!";
    }

    return null;
}
export const validateCountyCertificate = (year: any, certifications: any) => {
    let validationResult: { year: string | null; success: boolean | null } = {
        year: validateTaxYear(year, certifications),
        success: null
    };

    validationResult.success = validationResult.year === null; // true if year is null, else false
    return validationResult;
}


export function containsRecordForYear(nameKey: any, records: any) {
    if (!records || records.length === 0) {
        return false;
    }

    for (const element of records) {
        if (!element) continue;

        if (element.toString() === nameKey.toString() ||
            element.year?.toString() === nameKey.toString() ||
            element.taxYear?.toString() === nameKey.toString()) {
            return true;
        }
    }

    return false;
}

export const isNullOrEmpty = (data: any): boolean => {
    return (
        data === null ||
        data === undefined ||
        data === '' ||
        (Array.isArray(data) && data.length === 0) ||
        (typeof data === 'object' && Object?.keys(data).length === 0)
    );
}

export function getCurrentTaxYear() {
    return new Date().getMonth() < 9 ? new Date().getFullYear() - 1 : new Date().getFullYear()
}


export const showToast = (message = "", type: TypeOptions = "info") => {
    if (isNullOrEmpty(message) || isNullOrEmpty(type) || !type) {
        return;
    }

    toast(message, { type: type, toastId: message });

};

export function getFirstNonNull(values: any[]): any {
    return values.find(v => v != null);
}

export function serialize(obj: any) {
    let str = [];
    for (let p in obj)
        if (obj.hasOwnProperty(p)) {
            if (Array.isArray(obj[p])) {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p].join(',')));
            } else {
                str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
            }
        }
    return str.join("&");
}
interface DashboardQuery {
    pageNumber: number;
    pageSize: number;
    sort: string;
    sortOrder: "ASC" | "DESC"; // Using a union type for specific values
    [key: string]: any; // Allows for additional properties to be merged in
}
export function createMergedDashboardQuery(objectToMerged: Record<string, any> | null = null): DashboardQuery {
    const defaultQuery: DashboardQuery = {
        pageNumber: 0,
        pageSize: 15,
        sort: "creationDate",
        sortOrder: "DESC"
    };

    if (objectToMerged === null) {
        return defaultQuery;
    }

    // TypeScript understands the spread operator here
    return { ...defaultQuery, ...objectToMerged } as DashboardQuery;
}

export function getProductStatusDotInfo(productStatus: string): { color: string; title: string } {
    const statusMap: Record<string, { color: string; title: string }> = {
        NEW: { color: '#96938e', title: 'New' },
        PENDING: { color: '#FFB631', title: 'Pending' },
        SAVED: { color: '#FFB631', title: 'Pending' },
        COMPLETED: { color: '#4682B4', title: 'Completed' },
        QC: { color: '#bf00ff', title: 'QC' },
        DELIVERED: { color: '#73B446', title: 'Delivered' }
    };
    const errorInfo = { color: '#B44646', title: 'Error' };
    return statusMap[productStatus] || { ...errorInfo, title: productStatus };
}

export const getShortProductName = (productType: any) => {

    if (productType.includes("TAX_") === true) {
        return "Tax";
    } else if (productType.includes("HOA_FULL") === true) {
        return "HOA F.";
    } else if (productType.includes("HOA_CONTACT") === true) {
        return "HOA C.";
    } else {
        return productType;
    }

}

export const createOptionListForSelectTag = (data: any[] | null = null, label = "", value = "", suffix = "", overrideLabel = "") => {
    let list: any[] = [];

    if (isNullOrEmpty(data) || isNullOrEmpty(label) || isNullOrEmpty(value)) {
        return list;
    }

    if (!Array.isArray(data)) {
        return list;
    }

    list = data?.map(cur => {


        const labelText =
            (isNullOrEmpty(overrideLabel) || isNullOrEmpty(cur[overrideLabel]))
                ? cur[label] // Fallback to the label if overrideLabel is empty or not found
                : cur[overrideLabel]; // Use overrideLabel if it's valid


        return {
            value: cur[value],
            label: labelText + (isNullOrEmpty(suffix) ? "" : " (" + cur[suffix] + ")"),
        }
    })

    return list;
}

export const filterObjectFromArray = (array: any[], keyToCompare: string | number, value: string | number) => {
    if (isNullOrEmpty(array)) {
        return null
    }
    const filteredItem = array.find((item) => item[keyToCompare] === value);
    return filteredItem ?? null;
}

export const createOptionTypeListFromArray = (array: string[]) => {
    if (isNullOrEmpty(array)) {
        return []
    }
    return array.map(cur => ({ label: cur, value: cur }))
}

export function handleEnterKey(e: any) {
    if (e.keyCode === 13) {
        e.preventDefault();
    }
}

export const getSelectedValueFromEnum = (enumList: any, includeValue: any) => {
    let selected: any[] = [];
    enumList !== undefined && enumList.length > 0 && enumList.forEach((el: any) => {
        if (el.constant.includes(includeValue)) {
            selected.push(el.constant);
        }
    })
    return selected;
}

export function computeRowTextColor(redColor: boolean, bold: boolean): string {
    const classNames: string[] = [];

    if (redColor) {
        classNames.push('text-error-1');
    }
    if (bold) {
        classNames.push('font-bold');
    }

    return classNames.filter(Boolean).join(' ');
}
export function computeRowBgColor(yellowColor: boolean, bold: boolean): string {
    const classNames: string[] = [];

    if (yellowColor) {
        classNames.push('bg-[#FFFD80]');
    }
    if (bold) {
        classNames.push('font-bold');
    }

    return classNames.filter(Boolean).join(' ');
}
export const notificationSorting = (notificationList: any, sortingKeyArrayInOrder: any, order: any) => {
    return _.orderBy(notificationList, sortingKeyArrayInOrder, order);
}

export function getNotificationIcon(type: any) {
    switch (type) {
        case 'SCRAPER':
            return 'fa fa-globe cursor-pointer icon_size';
        case 'ASSIGNED':
            return 'fa fa-briefcase cursor-pointer icon_size';
        case 'MESSAGE':
            return 'fa fa-message icon_size';
        case 'MAINTENANCE':
            return 'fa fa-wrench icon_size';
        case 'BOND':
            return 'cursor fa fa-tasks icon_size';
        case 'AVANTA':
            return 'cursor fa fa-tasks-alt icon_size';
        default:
            return 'fa fa-clock cursor icon_size';
    }
}

export function getHumanReadableDateDifference(startDate: any, endDate = moment()) {
    let duration = moment.duration(endDate.diff(startDate));
    return duration.humanize() + " ago";
}

export const removeItemAtIndex = (array: any[], index: number) => {
    if (index < 0 || index >= array.length) {
        return array;
    }
    return [...array.slice(0, index), ...array.slice(index + 1)];
};

export const getProductTypeForBarChartLabel = (label: any, productTypeEnum: any) => {
    switch (label) {
        case "Tax":
        case "Tax Update":
            return getSelectedValueFromEnum(productTypeEnum, "TAX_");

        case "NTP Update":
            return ["NTP"];

        case "HOA":
        case "HOA Update":
            return getSelectedValueFromEnum(productTypeEnum, "HOA_");

        default:
            return [label];
    }
}

export const getBooleanDisplayIcon = (value: any = "", trueTitle = "", falseTitle = "", className = "ml-4") => {
    return (
        <>
            {value !== "" ?
                <div>
                    <i title={value ? trueTitle : falseTitle}
                        className={value ? `fa fa-check-circle text-text-5 ${className}` : `fa fa-times-circle text-error-3 ${className}`}
                    />
                </div> :
                <></>
            }
        </>
    )
}

export function computeBackgroundColor(product: any) {
    switch (product) {
        case 'Tax':
            return '#B44646';

        case 'Tax Update':
            return '#c05f5f';

        case 'HOA':
            return '#FFB631';

        case 'HOA Update':
            return '#e5b65f';

        case 'NTP':
            return '#4682B4';

        case 'NTP Update':
            return '#5d92be';

        default:
            return '#6855ff';
    }
}

interface ProductCountItem {
    productType: string;
    count: number;
    reorder: boolean;
}

interface ProductCountItem {
    productType: string;
    count: number;
    reorder: boolean;
}

export function computeAutomatedOrderPercentLabelAndCount(period: string, dailyCounts: any[], productTypes: string | any[], onlyUpdates: any, onlyLabels = false) {
    let valueToReturn: any[] = [];

    dailyCounts.length > 0 &&
        dailyCounts.sort((a: any, b: any) => new Date(a.date).getTime() - new Date(b.date).getTime())
            .map((cur: any) => {
                if (onlyLabels) {

                    computeBarChartLabels(cur, valueToReturn, period);
                } else {
                    let productCountItems = cur?.productPercentItems.filter((p: any) => productTypes.includes(p.productType) && p.reorder === onlyUpdates);
                    let total = productCountItems.map((p: {
                        percentCount: any;
                    }) => p?.percentCount).reduce((a: any, b: any) => a + b, 0);
                    valueToReturn.push(total);
                }
            });

    return valueToReturn;
}

export function computeLabelAndCount(
    period: string,
    dailyCounts: any[],
    productTypes: string[] = [],
    onlyUpdates: boolean,
    onlyLabels = false
) {
    const valueToReturn: any[] = [];

    dailyCounts
        .sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime())
        .forEach(cur => {
            if (onlyLabels) {
                computeBarChartLabels(cur, valueToReturn, period);
            } else {
                const total = cur.productCountItems
                    .filter((p: any) => productTypes.includes(p.productType) && p.reorder === onlyUpdates)
                    .reduce((sum: any, p: any) => sum + p.count, 0);
                valueToReturn.push(total);
            }
        });

    return valueToReturn;
}



export function computeBarChartLabels(cur: any, valueToReturn: any[], period: string) {
    const dateString = cur.zonedDateTime?.toString?.();

    if (!dateString) {
        valueToReturn.push("Invalid Date");
        return;
    }

    if (period === 'MONTHS') {
        valueToReturn.push(moment(dateString).format("MMMM YYYY"));
    } else if (period === 'DAYS') {
        valueToReturn.push(moment(dateString).format("MMM Do"));
    } else {
        const start = moment(dateString);
        const end = start.clone().add(6, 'days');
        valueToReturn.push(`${start.format("MMM Do")} - ${end.format("MMM Do")}`);
    }
}

function formatMonthYear(date: any) {
    const [year, month] = date.split('-');
    return `${getMonthName(month)} ${year}`;
}

function formatMonthDay(date: any) {
    const [month, day] = date.split('-');
    return `${getMonthName(month)} ${parseInt(day)}${getDaySuffix(parseInt(day))}`;
}

function addDays(dateString: string | number | Date, daysToAdd: number) {
    const date = new Date(dateString);
    date.setDate(date.getDate() + daysToAdd);
    return date.toISOString().split('T')[0];
}

function getMonthName(month: string) {
    const months = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
    return months[parseInt(month) - 1];
}

function getDaySuffix(day: number) {
    if (day >= 11 && day <= 13) {
        return 'th';
    }
    const lastDigit = day % 10;
    switch (lastDigit) {
        case 1:
            return 'st';
        case 2:
            return 'nd';
        case 3:
            return 'rd';
        default:
            return 'th';
    }
}

export const getBooleanWithDisplayIcon = (value: any = "", trueTitle = "", falseTitle = "", customerLevel = "") => {
    let iconColor = "gray"; // Default color is gray

    if (customerLevel === "TENANT") {
        // If user's customer level is TENANT, set icon color based on value
        iconColor = value ? "red" : "green";
    }

    return (
        <>
            <div>
                <i
                    title={value ? trueTitle : falseTitle}
                    className={value ? `fa-solid fa-graduation-cap align--center enabled ` : `fa-solid fa-graduation-cap align--center enabled`}
                    style={{ "color": iconColor }}
                />
            </div>
        </>
    );
};

export function isValidCustomer(storageData: any) {
    const items = storageData?.items;
    return items?.customerLevel !== "CUSTOMER" ||
        (items?.customerLevel === "CUSTOMER" && items?.fulfillmentCandidate === true);
}


export let booleanChecks = [{ value: false, label: "Disabled" }, { value: true, label: "Enabled" }]


//validatePassword
export interface PasswordValidationErrors {
    uppercaseChar?: string;
    lowercaseChar?: string;
    number?: string;
    specialChar?: string;
    length?: string;
    match?: string;
    isValidSubmission: boolean;
    uppercaseCheck?: string;
    lowercaseCheck?: string;
    numberCheck?: string;
    specialCharCheck?: string;
    lengthCheck?: string;
}

export const validatePassword = (password: string, confirmPassword: string): PasswordValidationErrors => {
    const regexForUppercase = new RegExp("(?=.*[A-Z])");
    const regexForLowercase = new RegExp("(?=.*[a-z])");
    const regexForNum = new RegExp(/\d/);
    const regexForSpecialChar = new RegExp("(?=.*\\W)");
    const regexForLength = new RegExp(/^.{12,50}$/);

    let error: PasswordValidationErrors = {
        isValidSubmission: false,
    };

    if (!regexForUppercase.test(password)) {
        error.uppercaseChar = "Must contain at least one uppercase letter (A - Z)";
    } else {
        error.uppercaseCheck = "true";
    }

    if (!regexForLowercase.test(password)) {
        error.lowercaseChar = "Must contain at least one lowercase letter (a - z)";
    } else {
        error.lowercaseCheck = "true";
    }

    if (!regexForNum.test(password)) {
        error.number = "Must contain at least one number (0 - 9)";
    } else {
        error.numberCheck = "true";
    }

    if (!regexForSpecialChar.test(password)) {
        error.specialChar = "Must contain at least one special character (e.g. !, #, $, %)";
    } else {
        error.specialCharCheck = "true";
    }

    if (!regexForLength.test(password)) {
        error.length = "Must contain between 12 and 50 characters";
    } else {
        error.lengthCheck = "true";
    }

    if (password !== confirmPassword && confirmPassword !== null && confirmPassword !== "") {
        error.match = "Password and Confirm Password don't match!";
    } else {
        error.match = "";
    }

    error.isValidSubmission =
        regexForUppercase.test(password) &&
        regexForLowercase.test(password) &&
        regexForNum.test(password) &&
        regexForSpecialChar.test(password) &&
        regexForLength.test(password);

    if (error.isValidSubmission) {
        delete error.uppercaseChar;
        delete error.lowercaseChar;
        delete error.number;
        delete error.specialChar;
        delete error.length;
    }

    return error;
};

export const reorderProperties = (obj: any) => {
    return {
        type: obj.type?.value,
        firstName: obj.firstName,
        middleName: obj.middleName,
        lastName: obj.lastName,
        nameUnparsed: obj.nameUnparsed,
    };
};


export const getFileName = (entity: string, extension = '.csv') => {
    let instance = new Date();
    return entity + "_" + (instance.getMonth() + 1) + "-" + instance.getDate() + "-" + instance.getFullYear() + "_" + instance.getTime() + extension;
}

export function usePrevious(value: any) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}


export const fetchPdf = async (url: string): Promise<string> => {
    try {
        const baseUrl = process.env.REACT_APP_BASE_URL || "http://localhost:8023";
        const fullUrl = `${baseUrl}${url}`;
        // @ts-ignore
        const response = await fetch(fullUrl, {
            method: "GET",
            headers: {
                'Authorization': `${localStorage.getItem('authToken')}`,
                "Cache-Control": "no-cache",
                Pragma: "no-cache",
                Accept: "*/*", // Accept all file types
            },
        });

        if (!response.ok) {
            throw new Error("Failed to fetch file");
        }

        const blob = await response.blob();
        return URL.createObjectURL(blob);
    } catch (error) {
        console.error("Error fetching PDF file:", error);
        throw error;
    }
};

export interface UserSetting {
    group: string;
    key: string;
    value: string | undefined;
    checked?: boolean;
}

export const dateTimeOffset = (dateValue: string, dateFormat = "MM/DD/YY h:mm a") => {
    if (dateValue === null) {
        return null;
    }
    return formatValueAsDate(dateValue, dateFormat)

}

export const datePicker = (periodValue: any, setVal: any, isReadOnly = false) => {
    const val = periodValue ? moment.utc(periodValue).toDate() : null;

    return (
        <>
            <DatePicker
                onChange={(value: any) => {
                    if (value) {
                        const selectedMoment = moment(value);
                        setVal(selectedMoment);
                    } else {
                        setVal(null);
                    }
                }}
                value={val}

                dayPlaceholder={"dd"}
                monthPlaceholder={"mm"}
                format={"MM-dd"}
                onKeyDown={(e: any) => {
                    e.preventDefault();
                }}
                className={"w-full"}
                disabled={isReadOnly}
            />
        </>
    );
};
export const formatByte = (bytes: any, precision: any) => {
    let kilobyte = 1024;
    let megabyte = kilobyte * 1024;
    let gigabyte = megabyte * 1024;
    let terabyte = gigabyte * 1024;

    if (bytes === null || bytes === "") {
        return "-";
    }

    if ((bytes >= 0) && (bytes < kilobyte)) {
        return bytes + ' B';

    } else if ((bytes >= kilobyte) && (bytes < megabyte)) {
        return (bytes / kilobyte).toFixed(precision) + ' KB';

    } else if ((bytes >= megabyte) && (bytes < gigabyte)) {
        return (bytes / megabyte).toFixed(precision) + ' MB';

    } else if ((bytes >= gigabyte) && (bytes < terabyte)) {
        return (bytes / gigabyte).toFixed(precision) + ' GB';

    } else if (bytes >= terabyte) {
        return (bytes / terabyte).toFixed(precision) + ' TB';

    } else {
        return bytes + ' B';
    }
}

export interface HeaderGroup {
    Header: string | { props: { title: string } };
    defaultHidden?: boolean;
    canBeHidden?: boolean;
}

export function getUserSettingListAll(
    headerGroupArray: HeaderGroup[],
    grid: string,
    pageNumber: number | null = null,
    pageControl: string | null = null
): UserSetting[] {
    const userSettingsArray: UserSetting[] = [
        {
            group: grid,
            key: "pageNumber",
            value: pageNumber !== null ? pageNumber.toString() : "15",
        },
        {
            group: grid,
            key: "pageControl",
            value:
                pageControl !== null
                    ? pageControl.toString()
                    : PageControl.find(cur => cur.constant === 'BOTTOM')?.constant,
        },
    ];

    headerGroupArray.forEach((curHeader) => {
        userSettingsArray.push({
            group: grid,
            key: typeof curHeader.Header === "object" ? curHeader.Header.props.title : curHeader.Header,
            value: !(curHeader?.defaultHidden && curHeader?.canBeHidden) ? "show" : "hide",
            checked: !(curHeader?.defaultHidden && curHeader?.canBeHidden),
        });
    });

    return userSettingsArray;
}

export const handleFileAction = async (fileId: any, path: any, isDownload = false, filename = '', tgxFileType = '', fileSize = null) => {

    const fetchPdfFile = async (fileId: any, tgxFileType: string, fileSize = null, filename = '') => {
        const url = tgxFileType === 'COLLECTOR_FILE'
            ? `${path}${fileId}/${fileSize}?fileName=${encodeURIComponent(filename)}`
            : `${path}${fileId}`;

        return await fetchPdf(url); // Use the common fetch function
    };
    try {
        const fileUrl = await fetchPdfFile(fileId, tgxFileType, fileSize, filename);

        // Define viewable file types
        const viewableFileExtensions = ['.pdf', '.jpg', '.jpeg', '.png', '.txt']; // Add other viewable extensions as needed
        const fileExtension = filename.slice(filename.lastIndexOf('.')).toLowerCase();

        // Determine if the file is viewable or not
        const isViewableFile = viewableFileExtensions.includes(fileExtension);

        if (isDownload || !isViewableFile) {
            // If the file is non-viewable or if isDownload is true, download it
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            // Otherwise, open in a new tab
            window.open(fileUrl, '_blank');
        }
    } catch (error) {
        console.error('Error handling file action:', error);
    }
};

export function commonSortingList(list: any, sortingKeyArrayInOrder: any, order: any) {
    return _.orderBy(list, sortingKeyArrayInOrder, order);
}

export function getProductIcon(type: any) {

    if (type.includes("TAX_") === true) {
        return "fa-2x fa-scroll fas  notClickable";
    } else if (type.includes("HOA_") === true) {
        return "fas fa-house-flag fa-2x notClickable";
    } else if (type.includes("NTP") === true) {
        return "fa-solid fa-gavel fa-2x  notClickable";
    } else {
        return "fa-2x fa-scroll fas notClickable";
    }
}

export function getPrimitiveArray(array: any[] = [], key: string): string[] {
    if (!array || array.length === 0) {
        return [];
    }
    return _.map(array, key);
}

export function getObjectiveArray(array: any[] = []) {
    if (!array || array.length === 0) {
        return [];
    }

    return _.map(array, (curValue) => ({ label: curValue, value: curValue }));
}

export async function CalculatedDueValue(totalTaxCalculatorObj: any, setRender: any, list: any, index: any) {
    try {
        const response = await axiosInstance.post(`/ajax/estimate-total-calculated-due`, totalTaxCalculatorObj);
        list[index].calculatedDue = response.data;
        setRender(new Date().getMilliseconds());
        return response.data;
    } catch (error) {
    }
}

export function formatValueAsPhoneNumber(phoneNumber: any, displayType: "text" | "input" = "text") {
    return phoneNumber ? <>
        <NumberFormat value={phoneNumber} format="(###) ###-####" displayType={displayType}
            allowEmptyFormatting
            mask="_" />
    </> : null;
}

export function doesCurrentTaxYearMatchCurrentYear() {
    return getCurrentTaxYear() === new Date().getFullYear();
}

export function sortAssessmentList(list: any, sortingKeyArrayInOrder: any, order: any) {
    return _.orderBy(list, sortingKeyArrayInOrder, order);
}

export function sortByKeysPriority(jurisdictionList: any, sortingKeyArrayInOrder: any, order: any) {
    return _.orderBy(jurisdictionList, sortingKeyArrayInOrder, order);
}

export function sortCollectorSummaryList(summary: any, sortingKeyArrayInOrder: any, order: any) {
    return _.orderBy(summary, sortingKeyArrayInOrder, order);
}

export function sortTaxSuits(taxSuits: any) {
    return []
        .concat(...taxSuits)
        .sort((a: any, b: any) => convertLowerCase(a.payee).localeCompare(convertLowerCase(b.payee)));
}

export function convertLowerCase(value: any) {
    if (value != null && value !== '') {
        return value.toLowerCase();
    }
    return value != null ? value : "";
}

export function returnAddNewPropertyOption(options: any) {

    if (Array.isArray(options) && options.length === 0) {
        options.unshift(addNewDefaultSelectorValue)
        return options;
    }
    if (Array.isArray(options) && options[0].id === addNewDefaultSelectorValue.id) {
        return options;
    } else {
        options.unshift(addNewDefaultSelectorValue)
        return options;
    }

}

export function trimSpace(val: any) {
    return val != null && val !== "" ? val.trim() : val;
}

export const CommonSubmitLoader = (disable: any, title: any, className: string | null = null, isValidSubmission = false, formType = "", isLoading = false) => {
    return (<>
        {disable === true ?
            <button disabled={true}
                className={`${className !== null ? className + " btn_success_spinner" : "cm_btn btn_success_spinner"} flex disabled:cursor-not-allowed`}>
                <>
                    <>
                        {title}
                        {isLoading && <>...<TailSpinLoader /></>}
                    </>
                </>
            </button>
            :
            <Button isDisabled={isValidSubmission !== null && !isValidSubmission}
                className={`${className !== null ? className : "cm_btn ml-0"} disabled:bg-[#969da4] disabled:text-text-4 disabled:cursor-not-allowed`}
                title={!isValidSubmission ? title : ""} btnText={title} type="submit" />
        }
    </>)
}

export const returnNestedKeyValues = (obj: any, path: any): any => {

    if (obj === null || obj === undefined) {
        return "";
    }

    const keys = path.split(".");
    const currentKey = keys[0];
    const remainingKeys = keys.slice(1);

    if (remainingKeys.length === 0) {
        return obj[currentKey];
    }
    const nestedObj = obj[currentKey];
    if (nestedObj == null) {
        return "";
    }

    return returnNestedKeyValues(nestedObj, remainingKeys.join("."));

}


// Function to format the names into a string
export function formatNames(list: string[]): string {
    if (list.length === 0) {
        return ""; // Return empty string if the list is empty
    }
    if (list.length === 1) {
        return list[0];
    }
    return list.join(" & ");
}

// Function to split names by '||' and format them
export function formatBuyerSellerNames(names: string | null): string {
    if (!names || names.trim() === '') {
        return '';
    }
    const nameArray = names.split('||').map(name => name.trim());
    return formatNames(nameArray);
}


export const postalTitle = "*Postal code must follow the ZIP or ZIP+4 format.";
export const postalPattern = "^[0-9]{5}(?:-[0-9]{4})?$";

export async function loadPdf(id: any) {
    try {
        const url = `/ajax/view-file/${id}#zoom=45`;
        const fileUrl = await fetchPdf(url);

        const iframe = document.querySelector("iframe");
        if (iframe) {
            iframe.src = fileUrl;
            // Revoke the object URL after the iframe has loaded
            iframe.onload = () => {
                window.URL.revokeObjectURL(fileUrl);
            };
        } else {
            console.error("No iframe element found to display PDF");
        }
    } catch (error) {
        console.error("Error loading PDF:", error);
    }
}

export function selectDocument(props: any, setData: any, setProps: any) {
    return (<>
        <a
            className={'active cursor'}
            onClick={(e) => {
                e.preventDefault();
                setData(props.data);
                setProps(props.row.original.id);
                loadPdf(props.row.original.id);
            }}
        >{props.value}
        </a>
    </>)
}

export const transformValueLabelToValue = (input: any): any => {
    if (Array.isArray(input)) {
        return input.map(transformValueLabelToValue);
    } else if (input && typeof input === "object") {
        // Detect value-label pairs
        if (
            Object.keys(input).length === 2 &&
            "value" in input &&
            "label" in input
        ) {
            return input.value;
        }

        const result: any = {};
        for (const key in input) {
            result[key] = transformValueLabelToValue(input[key]);
        }
        return result;
    }

    return input;
};

export const getActionTextForCard = (actionText: any, actor: any, actionDate: any) => {
    return (<>
        <span>{actionText}</span>
        <span style={{ fontStyle: "italic" }}>{actor}</span>
        <span> on </span>
        <span style={{ fontStyle: "italic" }}>
            {formatValueAsDate(actionDate)}
        </span>
    </>)
}

export interface OptionType {
    id: string | number;

    [key: string]: any;
}

export const appendNewOption = (
    options: OptionType[] | undefined,
    addNewDefaultSelectorValue: OptionType
): OptionType[] => {
    if (!Array.isArray(options)) return [addNewDefaultSelectorValue];

    if (options.length === 0) {
        return [addNewDefaultSelectorValue];
    }

    if (options[0]?.id === addNewDefaultSelectorValue.id) {
        return options;
    }

    return [addNewDefaultSelectorValue, ...options];
};


export const createFormattedDate = (text: any, dateFormat = "MM/DD/YY h:mm a", titleDateFormat = dateFormat) => {
    let formattedDate = formatValueAsDate(text, dateFormat);
    let titleFormattedDate = dateFormat !== titleDateFormat ? formatValueAsDate(text, titleDateFormat) : formattedDate;

    return (<span title={titleFormattedDate ?? undefined}
        className="formatted_date">{formattedDate} </span>)
}

export function computeBuyerSellerNote(buyerName: any, sellerName: any) {

    if ((sellerName == null || sellerName === "") && (buyerName == null || buyerName === "")) {
        return null;
    } else if (buyerName != null && buyerName !== "" && sellerName != null && sellerName !== "") {
        return "BUYER: " + formatBuyerSellerNames(buyerName) + "\t\t\t\t\tSELLER: " + formatBuyerSellerNames(sellerName);
    } else if (buyerName != null && buyerName !== "" && (sellerName == null || sellerName === "")) {
        return "BUYER: " + formatBuyerSellerNames(buyerName) + "\t\t\t\t\tSELLER: " + '-'
    } else {
        return "BUYER: " + '-' + "\t\t\t\t\tSELLER: " + formatBuyerSellerNames(sellerName);
    }
}
export function computePropertyAddressNote(orderData: any, certificate: any) {
    const includeOriginalPropertyNote = orderData.data?.branchDTO?.includeOriginalPropertyNote;
    if (certificate.accounts && certificate.accounts.length > 0 && includeOriginalPropertyNote) {
        const isSitusNotStartsWithNumber = _.some(certificate.accounts, (obj) => {
            const situsAddress = _.get(obj, "situsAddress", '');
            const firstChar = situsAddress ? situsAddress[0].trim() : null;
            return firstChar && isNaN(parseInt(firstChar));
        });
        const propertyAddress = orderData.items?.properties?.[0]?.addressLine1;
        return isSitusNotStartsWithNumber && includeOriginalPropertyNote && propertyAddress
            ? "P/A " + propertyAddress
            : null;
    }
    return null;
}

export const computeAssociationVerifiedByColor = (verifiedDate: any, associationVerificationDays: any) => {
    if (verifiedDate === null) {
        return "darkorange";
    }

    const formattedDate = formatValueAsDate(verifiedDate, "MM/DD/YYYY");

    if (formattedDate) {
        const diffInMs = Math.abs(new Date(formattedDate).getTime() - new Date().getTime());
        // do something with diffInMs
        let computedDays = diffInMs / (1000 * 60 * 60 * 24);
        switch (computedDays < associationVerificationDays) {
            case true:
                return "blue";
            case false:
                return "red";
            default:
                return "darkorange"
        }
    } else {
        // handle case when verifiedDate is null
        console.warn("verifiedDate is null or invalid");
    }

}

export function prePopulateFilterTagFromUrl(filterModalOptions: any) {
    if (window.location.search && window.location.search !== "") {
        if (deserializeObject(window.location.search) instanceof Object && Object.keys(deserializeObject(window.location.search)).length > 0) {
            let urlObj = deserializeObject(window.location.search);
            filterModalOptions.map((cur: any) => {
                Object.keys(urlObj).map((cur1) => {
                    if (cur.filterModalKeyAccessor === cur1) {
                        cur?.setShowModalValue(urlObj[cur1])
                    }
                    if (cur.filterModalKeyAccessor.toString() + "ShowValue" === cur1) {
                        cur?.setShowModalTagValue(urlObj[cur1])
                    }
                })
            })
        }
    }

}

//deserialize the object (use this only for search purpose)
export function deserializeObject(input: any) {
    const payload: any = {};
    const params = new URLSearchParams(input);

    for (let [key, val] of params.entries()) {
        if (key.endsWith('[]')) {
            key = key.replace(/\[]$/, '');
            if (payload[key]) {
                payload[key].push(val);
            } else {
                payload[key] = [val]
            }
        } else {
            if (val === 'true' || val === 'false') {
                payload[key] = val === 'true';
            } else {
                payload[key] = val;
            }
        }
    }

    return payload;
}


export const addCountyCertification = (countyId: any, certifications: any, setCertifications: any, editYear: any) => {
    let validationResult = validateCountyCertificate(editYear, certifications);
    if (!validationResult.success) {
        return validationResult;
    }

    let data = { countyId: countyId, taxYear: editYear };

    setCertifications([...certifications ?? [], data])

    return validationResult;
}

export const deleteCountyCertification = (index: any, setCertifications: any) => {
    setCertifications((oldItem: any) => {
        return oldItem.filter((item: any, i: any) => {
            return i !== index;
        })
    })
}

export const addTaxRate = (setTaxError: any, taxRates: any, setTaxRates: any, year: any, setYear: any, rate: any, setRate: any) => {
    setTaxError({})

    let taxRateData = { year, rate };
    let validationResult = validateTaxRateRecord(taxRateData, taxRates);

    setTaxError(validationResult);

    if (!validationResult.success) {
        return;
    }

    setTaxRates((oldItem: any) => {
        const safeOldItem = Array.isArray(oldItem) ? oldItem : [];
        return [...safeOldItem, taxRateData];
    });

    setYear("");
    setRate("");
}

export const validateTaxRateRecord = (values: any, taxRates: any) => {
    const validationResult = {
        year: validateTaxYear(values.year, taxRates),
        rate: validateTaxRate(values.rate),
        success: false     // ← now a boolean
    };

    validationResult.success =
        validationResult.year == null &&
        validationResult.rate == null;

    return validationResult;
};


export const validateTaxRate = (rate: any) => {
    if (!rate) {
        return "Rate is required!";
    }

    if (rate > 100) {
        return "Rate cannot be greater than 100";
    }

    return null;
}

//delete tax by id
export const deleteTaxRate = (id: any, { setTaxRates }: any) => {
    setTaxRates((oldItem: any) => {
        return oldItem.filter((eL: any, index: any) => {
            return index !== id;
        })
    })
}


export const addJurisdictionCode = (i: any, {
    jurisdictionCodes, setJurisdictionCodes, setCodeError, type, setType, code, setCode
}: any) => {
    let JurisdictionData = { type: type?.value, code };
    const error: any = {};
    if (code === "") {
        error.code = "*Code is required!";
        setCodeError(error);
    } else if (searchJurisdiction(type, code, jurisdictionCodes)) {
        error.code = "Combination already exist!";
        setCodeError(error);
    } else {
        setJurisdictionCodes((oldItem: any) => {
            return [...oldItem, JurisdictionData];
        });
        setType({
            value: "APPRAISAL_DISTRICT",
            label: "Appraisal District"
        });
        setCode("");
        setCodeError(error);
    }

}
export function searchJurisdiction(type: any, code: any, myArray: any) {
    for (const element of myArray) {
        if (element.type?.value?.toUpperCase() === type?.value?.toUpperCase() && element.code.toUpperCase() === code.toUpperCase()) {
            return true;
        }
    }
}


export const deleteJurisdictionCodes = (id: any, { setJurisdictionCodes }: any) => {
    setJurisdictionCodes((oldItem: any) => {
        return oldItem.filter((eL: any, index: any) => {
            return index !== id;
        })
    })
}

export function getStateValueFromParam(window: any, paramName = "state") {
    // Get the URLSearchParams object from the current URL
    const urlParams = new URLSearchParams(window.location.search);
    // Get the value of the "state" parameter
    return urlParams.get(paramName);
}


export function computeRegex(result: any) {

    const labels = ["Property County", "Owner Name", "Buyer/Borrower Name", "Property Address", "Closing Date", "File Number"];
    const indexes = labels.map(label => result.indexOf(label));

    const minIndex = _.minBy(indexes, index => (index === -1 ? Infinity : index));

    const conditions = [
        [minIndex === indexes[0], /(Short Legal|CAD Parcel Number|Property County)/g],
        [minIndex === indexes[1], /(Short Legal|CAD Parcel Number|Owner Name)/g],
        [minIndex === indexes[2], /(Short Legal|CAD Parcel Number|Buyer)/g],
        [minIndex === indexes[3], /(Short Legal|CAD Parcel Number|Property Address)/g],
        [minIndex === indexes[4], /(Short Legal|CAD Parcel Number|Closing Date)/g],
        [minIndex === indexes[5], /(Short Legal|CAD Parcel Number|File Number)/g]
    ];

    // @ts-ignore
    return _.find(conditions, condition => condition[0])[1];

}

export const setNestedValue = (obj: any, path: string[], value: any): any => {
    const [key, ...rest] = path;
    return {
        ...obj,
        [key]: rest.length
            ? setNestedValue(obj?.[key] ?? {}, rest, value)
            : value,
    };
};

export const removeInvalidAndTrimList = (items: any) => {
    return _.compact(_.map(items, _.trim))
}

export const getCurrentMonthStartDate = (): string => {
    const currentDate: Date = new Date();
    const currentMonthStart: Date = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
    const formattedStartDate: string = `${currentMonthStart.getFullYear()}-${(currentMonthStart.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-01`;
    return `${formattedStartDate} 00:00:00`;
}

export const percentage = (val1: any, val2: any) => {
    if (val2 === 0) {
        return 0.00;
    }
    return ((val1 / val2) * 100);
}


export function getEnumValueByConstant(enumPairs : any, constantValue : any) {
    if (constantValue) {
        return Array.isArray(enumPairs) && enumPairs.find(enumPair => constantValue === enumPair.constant)?.value;
    }
}